const NotFound: React.FC = () => {
    return (
        <>
        <h2>Page Not Found</h2>
        </>
    )
}

export default NotFound;